(function () {
    if (customElements.get('pcard-color-swatch')) return
    function getIsPc() {
        return !FoxTheme?.config.mqlMobile && !FoxTheme?.config.mqlTablet
    }

    function findEleByClass(ele, className) {
        if (ele === document.body || !ele) return null
        if (ele.className.indexOf?.(className) >= 0) return ele
        return findEleByClass(ele.parentElement, className)
    }

    function handleColorListMouseMove(ele) {
        let isMouseDown = false
        let lastPageX = null
        const moveEle = ele.querySelector('.swatches--product-card')
        const parentEle = moveEle.parentElement
        const eleForArrow = parentEle.parentElement

        const scrollWidth = (moveEle.children?.length ?? 0) * moveEle.children[0].clientWidth - 2
        let maxDiff = parentEle.offsetWidth - scrollWidth
        let translateX = 0
        let ancestor = findEleByClass(ele,'product-card__swatches-container')
        let isPC = getIsPc()

        const handleBodyMove = (e) => {
            e.stopPropagation()
        }
        
        function handleMouseDown(e) {
            e.stopPropagation()
            isMouseDown = true
            lastPageX = isPC ? e.pageX : e.touches[0]?.pageX

            ele.parentElement.addEventListener('mousemove', handleBodyMove)
        }
        
        function handleMouseUp(e) {
            e.stopPropagation()
            isMouseDown = false
            lastPageX = null
            ele.parentElement.removeEventListener('mousemove', handleBodyMove)
        }
        
        function handleMouseMove(e) {
            if (!isMouseDown || lastPageX === null) return
            e.stopPropagation()
            const curPageX = isPC ? e.pageX : e.touches[0]?.pageX
            const diff = lastPageX - curPageX
            translateX = Math.max(Math.min(0, translateX - diff), maxDiff)
            moveEle.style.transform = `translateX(${translateX}px)`
            lastPageX = curPageX
            updateStatusOfArrow(eleForArrow, translateX)
        }
        
        
        function initArrow (ele) {
            if (!ele) return
            if (![...ele.children]?.some((child) => child.className.indexOf('arrow') >= 0)) {
                return
            }

            const leftArrow = ele.querySelector('.arrow.left'), rightArrow = ele.querySelector('.arrow.right')
            leftArrow.classList.add('disabled')
            leftArrow.classList.remove('hidden')
            rightArrow.classList.remove('hidden')
            setTimeout(function() {
                maxDiff = parentEle.offsetWidth - scrollWidth
            }, 10);

            leftArrow.removeEventListener('click', handleArrowClick('left', ele))
            leftArrow.addEventListener('click', handleArrowClick('left', ele))
            rightArrow.removeEventListener('click', handleArrowClick('right', ele))
            rightArrow.addEventListener('click', handleArrowClick('right', ele))
        }

        function recoverArrow(ele) {
            if (!ele) return
            if (![...ele.children]?.some((child) => child.className.indexOf('arrow') >= 0)) {
                return
            }

            const leftArrow = ele.querySelector('.arrow.left'), rightArrow = ele.querySelector('.arrow.right')
            if (leftArrow.className.indexOf('hidden') < 0) {
                leftArrow.classList.add('hidden')
            }
            if (rightArrow.className.indexOf('hidden') < 0) {
                rightArrow.classList.add('hidden')
            }
            leftArrow.removeEventListener('click', handleArrowClick('left', ele))
            rightArrow.removeEventListener('click', handleArrowClick('right', ele))
        }
        
        function updateStatusOfArrow(parentEle, translateX) {
            if (!parentEle) return
            const leftArrowDom = parentEle.querySelector('.arrow.left'), rightArrowDom = parentEle.querySelector('.arrow.right')
            if (translateX <= maxDiff) {
                if (leftArrowDom.className.indexOf('disabled') >= 0) {
                    leftArrowDom.classList.remove('disabled')
                }
                if (rightArrowDom.className.indexOf('disabled') >= 0) return
                rightArrowDom.classList.add('disabled')
            } else if (translateX === 0) {
                if (rightArrowDom.className.indexOf('disabled') >= 0) {
                    rightArrowDom.classList.remove('disabled')
                }
                if (leftArrowDom.className.indexOf('disabled') >= 0) return
                leftArrowDom.classList.add('disabled')
            } else {
                if (rightArrowDom.className.indexOf('disabled') >= 0) {
                    rightArrowDom.classList.remove('disabled')
                }
                if (leftArrowDom.className.indexOf('disabled') >= 0) {
                    leftArrowDom.classList.remove('disabled')
                }
            }
        }
        
        function handleArrowClick(direction, parentEle) {
            return function (e) {
                const moveEleWidth = moveEle.offsetWidth, isLeftBtn = direction === 'left'
                translateX = translateX + (!isLeftBtn ? -moveEleWidth : moveEleWidth)
                translateX = Math.max(Math.min(0, translateX), maxDiff)
                moveEle.style.transform = `translateX(${translateX}px)`
                updateStatusOfArrow(eleForArrow, translateX)
            }
        }
        
        function handleMouseScroll() {
            if (parentEle.scrollLeft > 0) {
                parentEle.scrollLeft = 0
            }
        }
        
        if (ele && maxDiff < 0) {
            initArrow(eleForArrow)
            moveEle.style.justifyContent = 'flex-start'

            // parentEle.removeEventListener('scroll', handleMouseScroll)
            // parentEle.addEventListener('scroll', handleMouseScroll)
            if (isPC) {
                ele.removeEventListener('mousedown', handleMouseDown)
                ele.removeEventListener('mousemove', handleMouseMove)
                ele.removeEventListener('mouseup', handleMouseUp)
                ancestor.removeEventListener('mouseleave', handleMouseUp)
                
                ele.addEventListener('mousedown', handleMouseDown)
                ele.addEventListener('mousemove', handleMouseMove)
                ele.addEventListener('mouseup', handleMouseUp)
                ancestor.addEventListener('mouseleave', handleMouseUp)
            } else {
                ele.removeEventListener('touchstart', handleMouseDown)
                ele.removeEventListener('touchmove', handleMouseMove)
                ele.removeEventListener('touchend', handleMouseUp)
                ancestor.removeEventListener('mouseleave', handleMouseUp)
                
                ele.addEventListener('touchstart', handleMouseDown)
                ele.addEventListener('touchmove', handleMouseMove)
                ele.addEventListener('touchend', handleMouseUp)
                ancestor.addEventListener('mouseleave', handleMouseUp)
            }
        } else {
            recoverArrow(eleForArrow)
        }
        
    }


    class PCardColorSwatch extends HTMLElement {
        constructor() {
            super()
            this.inited = false
        }

        connectedCallback() {
            this.addEventListener('click', this.updateByobLinkFromSwatch.bind(this))
            setTimeout(()=> {
                this.init()
            }, 100)

            if (this.dataset.inCartDrawer) {
                const drawerDom = document.querySelector('cart-drawer')
                if (drawerDom) {
                    drawerDom.addEventListener(drawerDom.events.handleAfterShow, () => {
                        if (!this.inited) {
                            handleColorListMouseMove(this)
                            this.inited = true
                        }
                    })
                }
            } else if (this.dataset.switchTabIndex) {
                const switchTabIndex = this.dataset.switchTabIndex
                const tabComponent = this.closest('tabs-component')
                tabComponent.addEventListener('tabChange', (e) => {
                    const {selectedIndex} = e.detail
                    if (!this.inited && String(selectedIndex) === switchTabIndex) {
                        setTimeout(() => {
                            handleColorListMouseMove(this)
                        }, 800)
                        this.inited = true
                    }
                })
            }
        }

        init() {
            handleColorListMouseMove(this)

            window.addEventListener('resize', () => {
                handleColorListMouseMove(this)
            })
        }

        updateByobLinkFromSwatch(e) {
            const swatch = e.target.closest('.swatch-color')
            if (!swatch) return
            const inputDom = swatch.parentElement?.querySelector('input')
            const variantId = inputDom?.dataset?.id
            if (!variantId) return
            const productCard = this.closest('.product-card')
            const byobLinks = productCard?.querySelectorAll('[data-byob-link]')
            byobLinks?.forEach((dom) => {
                const baseUrl = dom.dataset.byobBaseUrl || dom.href.split('?')[0]
                const separator = baseUrl.includes('?') ? '&' : '?'
                dom.href = `${baseUrl}${separator}byob_variant=${variantId}`
                dom.dataset.byobVariantId = variantId
            })
        }
    }
    customElements.define('pcard-color-swatch', PCardColorSwatch);
})()
